import React from 'react';
import styled, { keyframes } from 'styled-components';
import loadingIcon from '../../static/images/xiaosong.png';

const rotate = keyframes`
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
`;
const LoadingStyle = styled.div`
    display: ${props => (props.isLoading ? 'block' : 'none')};
    .weui-mask_transparent {
        position: absolute;
        z-index: 1000;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
    }

    .weui-toast {
        position: absolute;
        z-index: 5001;
        width: 100%;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: rgba(17, 17, 17, 0.7);
        text-align: center;
        color: #ffffff;
    }

    .weui-icon_toast {
        margin: 22px 0 0;
        display: block;

        &.weui-icon-success-no-circle {
            &:before {
                color: #ffffff;
                font-size: 55px;
            }
        }
        &.weui-loading {
            margin: 50% auto 10px;
            width: 38px;
            height: 38px;
            background: url(${loadingIcon}) no-repeat center;
            background-size: cover;
            animation: ${rotate} 2s linear infinite;
        }
    }

    .weui-toast__content {
        margin: 0 0 15px;
    }
`;

function Loading(props) {
    return (
        <LoadingStyle isLoading={props.isLoading}>
            <div className="weui-mask_transparent" />
            <div className="weui-toast">
                <i className="weui-loading weui-icon_toast" />
                <p className="weui-toast__content">加载中</p>
            </div>
        </LoadingStyle>
    );
}

export default Loading;
